module.exports = __webpack_public_path__ + "img/eg-29-01.4dfc50b5.png";